export default {
    methods: {
        sendRequest(filter, name) {
            if (filter) {
                let url = new URL(window.location.href);
                url.searchParams.set(name, filter);
                window.location.href = url;
            }
        },
    }
};
